import axios from 'axios'

const logInCognitoUser = async (email, password) => {
  const authResponse = await axios.post('https://w2zgeuzzgg.execute-api.us-west-2.amazonaws.com/prod/log-in-with-email-and-password', {
    email,
    password
  })

  return authResponse.data.cognitoJWT
}

export default logInCognitoUser
